export const languagePathUrl = (lang) => {
  let result;
  lang === "zh-CN" ? (result = "cn") : (result = lang);
  return result === "en" ? "" : "/" + result;
};
